/*  */
import React, { useState, useEffect } from 'react';
import { withFormik, Field as Fieldmik, Form as Formiker } from 'formik'
import { Form as FormUi, Container, Segment, Button, Image, Loader, Grid } from 'semantic-ui-react'
import AddTitleBar from '../titleBar/add_titleBar'
import { MyNormalInput, MyTextArea } from '../dynamicComponent/myInput'
import CreateAxios from '../axiosComponent/createAxios'
import BranchTable from './branchTable'
import VehicleTable from './vehicleTable'
import UserForm from './userTable'
import ReadAxios from '../axiosComponent/readAxios'
import { isEmpty } from "lodash";
import cogoToast from 'cogo-toast';
import * as Yup from 'yup';
import MyCity from '../dynamicComponent/myCity';
import axios from "axios";
import qs from 'qs';
import AgreementModal from '../modalComponent/agreementModal';
import { preData } from '../../redux/reducers/preDataReducer';
import Vimeo from '@u-wave/react-vimeo';

var code;
const createCaptcha = () => {
    console.log("creating captcha");
    //clear the contents of captcha div first 
    if (document.getElementById('captcha')) {
        document.getElementById('captcha').innerHTML = "";
        var charsArray =
            "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
        var lengthOtp = 6;
        var captcha = [];
        for (var i = 0; i < lengthOtp; i++) {
            //below code will not allow Repetition of Characters
            var index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
            if (captcha.indexOf(charsArray[index]) == -1)
                captcha.push(charsArray[index]);
            else i--;
        }
        var canv = document.createElement("canvas");
        canv.id = "captcha";
        canv.width = 110;
        canv.height = 50;
        var ctx = canv.getContext("2d");
        ctx.font = "25px Georgia";
        ctx.strokeText(captcha.join(""), 0, 30);
        //storing captcha so that can validate you can save it somewhere else according to your specific requirements
        code = captcha.join("");
        console.log("captcha :", canv)
        document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element
    }
}



const RegisterTransporter = ({ values, touched, errors, setFieldValue, isSubmitting, preData, autoData }) => {

    const [cities, setcitytype] = useState([])
    const [open, setOpen] = React.useState(false)
    const [formSubmit, setformSubmit] = React.useState(0)
    const [agreement, setAgreement] = React.useState(false)
    const [DataLoading, setisDataLoading] = useState(false)
    const [preInfo, setPreInfo] = useState(null)

    useEffect(() => {
        getAllFetch();
        getAutoLogin();
        createCaptcha()
    }, []);
    const getAutoLogin = () => {
        setisDataLoading(true)
        let queryString = qs.parse(window.location.search)
        let draftKey = queryString["draft_reference_code"] || queryString["?draft_reference_code"] || null;
        if (draftKey != null) {
            axios.get(`${process.env.REACT_APP_COMMON_GATEWAY}/vendor_onboarding/vendor_draft?slug=${draftKey}`, {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `${localStorage.getItem("apiToken")}`,
                },
            }).then((response) => {
                if (response.data.resultSet[0] == null) {
                    cogoToast.error("Link has expired. Details already submitted")
                }
                else {
                    setPreInfo(JSON.parse(response.data.resultSet[0]['draftData']))
                    let mainData = JSON.parse(response.data.resultSet[0]['draftData'])
                    values.users = [{
                        realName: mainData.vendorUserRealName,
                        mobileNo: mainData.vendorUserPhone,
                        email: mainData.vendorUserEmail,
                        designation: mainData.designation
                    }]
                    values.transporterName = mainData.vendorCompanyName
                    values.companyCity = mainData.vendorCityId
                    values.companyPincode = mainData.vendorPincode
                    values.companyAddress = mainData.vendorAddress
                }
                setisDataLoading(false)
                createCaptcha()
            })
        }
        else {
            setisDataLoading(false)
            setPreInfo(null)
        }
    }
    const tutorialObj = [
        { name: 'Partner Onboarding', link: 'https://vimeo.com/667630471' },
    ]
    const getAllFetch = async () => {
        let [dataArray] = await Promise.all([ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/cityMaster`,
            readItems: { searchTerm: values.companyCity },
            method: "post"
        })]);
        // console.log("step 1")
        dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
        if (dataArray)
            setcitytype(
                dataArray.map((item, index) => {
                    return {
                        key: index + 1,
                        text: item.cityName,
                        value: item.city_id
                    };
                })
            );
    };

    const validateCaptcha = (event) => {
        if (document.getElementById("cpatchaTextBox").value == code) {
            values.isCaptchaValid = true
        } else {
            cogoToast.error('In Valid Captcha . Please Try again')
            values.isCaptchaValid = false
            setOpen(true)
            createCaptcha();
        }
    }

    let fetchingUserData = (data) => {
        if (data) {
            values.users = data
        }
    }

    let fetchingbranchData = (data) => {
        values.branches = data
    }
    let fetchingVehicleData = (data) => {
        values.vehicles = data
    }

    if (DataLoading) {
        return (
            <Segment>
                <center>
                    <Loader />
                </center>
            </Segment>
        )
    }
    else {
        return (
            <div className=" col-md-8 offset-md-2 w3-card white-bg mt-5 mb-5 no-margin">
                <Formiker >
                    <AddTitleBar Title="Partner Onboarding" /><br />
                    <Container fluid>
                        {/* {console.log(values)} */}
                        {+localStorage.getItem('customerNo') == 1158 ?
                            <Segment>
                                {tutorialObj.map((item, index) => {
                                    return (
                                        <>
                                            <Grid.Column className="text-center padding-bottom-40 adjust-video">
                                                <p className="video-header">{item.name}</p>
                                                <Vimeo
                                                    video={item.link}
                                                    autoplay={false}
                                                />
                                            </Grid.Column>
                                        </>
                                    )
                                })}
                            </Segment>
                            : null}
                        <Segment>
                            <div className="ui form tiny">
                                <FormUi.Group>
                                    <FormUi.Field width={4}>
                                        <label>Company Name *</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={4}>
                                        <Fieldmik component={MyNormalInput} name="transporterName" />
                                        {touched.transporterName && errors.transporterName && <label className="p-10 mt-2 w3-text-red">{errors.transporterName}</label>}
                                    </FormUi.Field>
                                    <FormUi.Field width={1} />
                                    <FormUi.Field width={3}>
                                        <label className="labelName mt-2">
                                            City *
                                        </label>
                                    </FormUi.Field>
                                    <FormUi.Field
                                        width={4}
                                        error={
                                            touched.companyCity && errors.companyCity
                                                ? true
                                                : false
                                        }
                                    >
                                        {/* {console.log(values.companyCity)} */}
                                        <Fieldmik component={MyCity} value={+values.companyCity} getCityInfo={(data) => {

                                        }} name="companyCity" />
                                        {touched.companyCity &&
                                            errors.companyCity ? (
                                            <div className="w3-small w3-text-red">
                                                {errors.companyCity}
                                            </div>
                                        ) : null}
                                    </FormUi.Field>
                                </FormUi.Group>
                                <FormUi.Group>
                                    <FormUi.Field width={4}>
                                        <label>Pincode *</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={4}>
                                        <Fieldmik component={MyNormalInput} name="companyPincode" value={values.companyPincode} maxLength={[6, 'Pincode cannot be longer than 6 digits']} />
                                        {touched.companyPincode && errors.companyPincode && <label className="p-10 mt-2 w3-text-red">{errors.companyPincode}</label>}
                                    </FormUi.Field>
                                    <FormUi.Field width={1} />
                                    <FormUi.Field width={3}>
                                        <label>Address *</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={4}>
                                        <Fieldmik component={MyTextArea} name="companyAddress" value={values.companyAddress} />
                                        {touched.companyAddress && errors.companyAddress && <label className="p-10 mt-2 w3-text-red">{errors.companyAddress}</label>}
                                    </FormUi.Field>
                                </FormUi.Group>
                            </div>
                        </Segment>
                        <div className="pb-3">
                            <div className="ui form tiny">
                                <UserForm gotUserData={fetchingUserData} autoData={preInfo} />
                            </div>
                        </div>
                        <div className="pb-3">
                            <React.Fragment>
                                <div className="ag-theme-material agOver" style={{ width: '100%', height: '100%' }}>
                                    <BranchTable gotBranchData={fetchingbranchData} />
                                </div>
                            </React.Fragment>
                        </div>
                        <div className="">
                            <React.Fragment>
                                <div className="ag-theme-material agOver" style={{ width: '100%', height: '100%' }}>
                                    <VehicleTable gotVehicleData={fetchingVehicleData} />
                                </div>
                            </React.Fragment>
                        </div>
                        <Segment>
                            <div className="ui form tiny">
                                <FormUi.Group >
                                    <FormUi.Field width={4}>
                                        <label className="labelName p-bold-400">Agreement PDF</label>
                                        <label className="p-8">Post Acknowledgement, it will be mutually signed. </label>
                                    </FormUi.Field>
                                    <FormUi.Field width={1}>
                                        <Button type="button" onClick={() => {
                                            let path = `${process.env.REACT_APP_MAIN_URL}/vendor_onboarding/public/agreement_pdf.pdf`
                                            window.open(path, '_blank')
                                        }} icon basic size="mini">
                                            <Image className="dashboard_icons"
                                                src='assets/svg/pdf.svg'
                                                size='mini'
                                                wrapped
                                            />
                                        </Button>
                                    </FormUi.Field>
                                    <FormUi.Field>
                                        <Fieldmik className="mt-2" type="checkbox" name="tnc" />
                                    </FormUi.Field>
                                    <FormUi.Field width={4}>
                                        <label className="mt-2">I Agree Terms and Conditions</label>
                                    </FormUi.Field>
                                    <FormUi.Field>
                                        <label className="mt-2">Captcha</label>
                                    </FormUi.Field>
                                    <FormUi.Field>
                                        <div id="captcha">
                                        </div>
                                    </FormUi.Field>
                                    <FormUi.Field>
                                        <input type="text" placeholder="Captcha" id="cpatchaTextBox" />
                                    </FormUi.Field>
                                </FormUi.Group>
                            </div>
                        </Segment>
                        <center><Button type="submit" onClick={() => validateCaptcha()} className="m-2" primary size="mini" disabled={values.tnc ? false : true} >Save</Button></center>
                    </Container>
                </Formiker>
                <AgreementModal
                    open={agreement}
                    onClose={() => setAgreement(false)}
                />
            </div>
        )
    }
}

const AddFormikTransporter = withFormik({
    mapPropsToValues({ transporterName, companyCity, companyAddress, companyPincode }) {
        // console.log('>>DATA', props.autoData)
        return {
            transporterName: transporterName || '',
            companyCity: companyCity || '',
            companyAddress: companyAddress || '',
            companyPincode: companyPincode || ''
        }
    },
    validationSchema: Yup.object().shape({
        transporterName: Yup.string().required('Company name Required'),
        companyCity: Yup.string().required('City Required'),
        companyAddress: Yup.string().required('Address Required'),
        companyPincode: Yup.string().required('Pincode Required').matches('^[1-9][0-9]{5}$', 'Please enter a valid pincode').max(6, 'Please enter a valid pincode')
    }),
    handleSubmit(values, { props }) {
        delete values.tnc
        values.customerNo = "1158"
        console.log(values)
        if (!values.users) {
            cogoToast.error("Please enter User Details")
        }

        if (!values.branches) {
            cogoToast.error("Please enter Branch Details")
        }

        if (!values.vehicles) {
            values.vehicles = []
        }

        if (values.users && values.isCaptchaValid && values.branches) {
            CreateAxios({
                publicURL: `${process.env.REACT_APP_MAIN_URL}/vendor_onboarding/insert`,
                payload: values
            }).then((res) => {
                if (res.status === 200) {
                    let alert = {
                        type: res.status,
                        messageHeader: res.message,
                        messageBody: res.data.message,
                    };
                    cogoToast.success("Partner Onboarding Successful")
                    setTimeout(() => { window.location.replace(`${process.env.REACT_APP_SNOWLINK}`); }, 1000)
                }
                else {
                    cogoToast.error(res.data)
                }
            }).catch((err) => {
                let alert = {
                    type: "error",
                    messageHeader: err.message,
                    messageBody: err.status,
                };
                let error_msg = err.response ? err.response.data.message : (err.message ? err.message : "Server Error")
                cogoToast.error(error_msg)
            });

        }
    }
})(RegisterTransporter)
export default AddFormikTransporter
